import { withStyles } from '@material-ui/core/styles'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { Create, SaveButton, SimpleForm, TextInput, Toolbar, translate } from 'react-admin'

const styles = {
  button: {
    marginTop: '1em',
  },
}

export const CustomToolbarAdd = (props) => (
  <Toolbar {...props}>
    <SaveButton label="ra.action.add" submitOnEnter={false} />
  </Toolbar>
)

class CategoryAdd extends Component {
  static propTypes = {
    accessible: PropTypes.bool,
  }
  render() {
    return (
      <Create {...this.props}>
        <SimpleForm redirect="list" toolbar={<CustomToolbarAdd />}>
          <TextInput source="name" resettable />
        </SimpleForm>
      </Create>
    )
  }
}

export default withStyles(styles)(translate(CategoryAdd))
